export default (array, keyFieldName, valueFieldName) => array.reduce((object, item) => ({
  ...object,
  [item[keyFieldName]]: item[valueFieldName],
}), {})
